var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',{attrs:{"title":"Media Upload"}},[_c('div',{staticClass:"page-data__container"},[[_c('media-upload',{ref:"upload",on:{"cancel":_vm.onCancel}})]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }